<template>

  <div>
    <div
      v-if="!value.length"
      class="alert alert-warning">
      Não há candidatos selecionados
    </div>
    <ul
      v-if="value.length"
      class="candidate-select-list">
      <li
        v-for="(candidate, index) in value"
        :key="index">
          <div class="photo">
            <Avatar
              :src="candidate.photo_media_url && !candidate.photo_media_url.includes(defaultImageUrl) ? candidate.photo_media_url : null"
              :name="candidate.name"
              size="26px"
              radius="13px"
              resize="100x100x1" />
          </div>
          <div class="name">
            {{ candidate.name }}
          </div>
          <a
            v-if="remove"
            href="javascript:void(0)"
            class="remove"
            @click="removeItem(index)">
            <i class="fas fa-times" />
          </a>
        </li>
    </ul>
  </div>

</template>

<script>
import config from '@/config'
import Avatar from '@/components/Parts/Avatar'

export default {
  name: 'SelectMultipleCandidates',
  components: {
    Avatar
  },
  props: {
    'value': {
      type: Array,
      default: () => { return [] }
    },
    'remove': {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      'values': []
    }
  },
  computed: {
    defaultImageUrl () {
      return config.default_image_url.candidate
    }
  },
  methods: {
    removeItem (index) {
      this.$emit('input', this.value.filter((val, key) => key !== index))
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
ul.candidate-select-list{
  list-style: none;
  padding: 0;
  margin: -3px;
}
  .candidate-select-list > *{
    display: inline-flex;
    background: rgba(0,0,0,0.1);
    border-radius: 5px;
    margin: 3px; 
    padding: 2px;
    align-items: center;
  }
  .candidate-select-list > * > .photo{
    flex: 1;
    max-width: 26px;
    max-height: 26px;
  }
    .candidate-select-list > * > .photo > img{
      width: 100%;
      border-radius: 13px;
    }
  .candidate-select-list > * > .name{
    flex: 1;
    line-height: 1em;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    max-width: 120px;
    padding: 4px;
  }
  .candidate-select-list > * > .remove{
    flex: 0;
    line-height: 1em;
    color: #000000;
    padding: 4px;
  }
</style>



// WEBPACK FOOTER //
// src/components/Fields/SelectMultipleCandidates.vue